import React from 'react';

const About = ({ data }) => (
  <div className="space-y-3">
    <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">
      About
    </div>
    <div className="whitespace-pre-line text-sm leading-relaxed text-slate-600">
      {data?.about_us}
    </div>
  </div>
);

export default About;
